import { Injectable } from '@angular/core';
import { isObject } from '@libraries/helpers';
import { Environment } from '@libraries/shared-env';
import { fromEvent, Subject } from 'rxjs';
import { Features } from './features';
import { LaunchDarklyService } from './launch-darkly.service';

export let featureFlags: Features;

@Injectable()
export class FeaturesService {
  private readonly config: Features;
  private featureUpdateSubject = new Subject<string>();
  public featureUpdate$ = this.featureUpdateSubject.asObservable();

  constructor(public launchDarkly: LaunchDarklyService, public env: Environment) {
    this.config = this.env.featureFlagConfig || {};
    featureFlags = this.config;

    // if window.featureFlags exists, then extend config with it
    if (isObject((window as { [key: string]: any })['featureFlags'])) {
      (window as { [key: string]: any })['featureFlags'] = Object.assign(
        this.config,
        (window as { [key: string]: any })['featureFlags']
      );
    } else {
      (window as { [key: string]: any })['featureFlags'] = this.config;
    }

    if (this.launchDarkly.hasClientId()) {
      this.launchDarkly.getFlags().subscribe((flags) => {
        Object.assign(this.config, flags);
      });
    }

    // WHENEVER FEATURES GET UPDATED, RE-DIGEST
    fromEvent(window, 'featureUpdate').subscribe(() => {
      // TO DO: Figure out which feature flag was updated.
      // Pass it on as argument to the featureUpdateSubject.
      // This way we can filter which updates we respond to.
      this.featureUpdateSubject.next('');
      setTimeout(() => {});
    });
  }

  isOn(feature: string) {
    return this.config[feature];
  }

  isOff(feature: string) {
    return !this.config[feature];
  }

  setFeature(feature: string, value: boolean) {
    if (this.config[feature] !== undefined) {
      this.config[feature] = value;

      if (typeof Event === 'function') {
        window.dispatchEvent(new Event('featureUpdate'));
      } else {
        // IE Event Polyfill
        const event = document.createEvent('Event');
        event.initEvent('featureUpdate', true, true);
        window.dispatchEvent(event);
      }
    }
  }
}
